import React, { Component } from 'react';
import {connect} from 'react-redux';
import Aux from '../../hoc/Auxx/Aux';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummry';
import axios from '../../axios-orders';
import Spinner from '../../components/UI/Spinner/Spinner';
//import orderSummary from '../../components/Burger/OrderSummary/OrderSummry';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
// import Checkout from '../Checkout/Checkout';
// import * as actionTypes from '../../store/actions/actionTypes';
import * as actions from '../../store/actions/index';

// const INGREDIENT_PRICES = {
//     salad: 0.5,
//     cheese: 0.4,
//     meat: 1.3,
//     bacon: 0.7
// };

export class BurgerBuilder extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {...}
    // }
    state = {
        // ingredients: {
        //     salad: 0,
        //     bacon: 0,
        //     cheese: 0,
        //     meat: 0
        // },
        //ingredients: null,
        // totalPrice : 4,
        // purchasable: false,
        purchasing: false
        // loading: false,
        // error: false
    }

    // addIngredientHandler = (type) => {
    //     const oldCount = this.state.ingredients[type];
    //     const updatedCount = oldCount + 1;
    //     const updatedIngredients = {
    //         ...this.state.ingredients
    //     };
    //     updatedIngredients[type] = updatedCount;
    //     const priceAddition = INGREDIENT_PRICES[type];
    //     const oldPrice = this.state.totalPrice;
    //     const newprice = oldPrice + priceAddition;
    //     this.setState({totalPrice:newprice,ingredients:updatedIngredients});
    //     this.updatedIngredientHandler(updatedIngredients);
    // }

    // removeIngredientHandler = (type) => {
    //     const oldCount = this.state.ingredients[type];
    //     if(oldCount<=0) return;
    //     const updatedCount = oldCount - 1;
    //     const updatedIngredients = {
    //         ...this.state.ingredients
    //     };
    //     updatedIngredients[type] = updatedCount;
    //     const priceDeduction = INGREDIENT_PRICES[type];
    //     const oldPrice = this.state.totalPrice;
    //     const newprice = oldPrice - priceDeduction;
    //     this.setState({totalPrice:newprice,ingredients:updatedIngredients});
    //     this.updatedIngredientHandler(updatedIngredients);
    // }

    componentDidMount(){
        this.props.onInitIngredients();
        // axios.get('https://react-my-burger-a4c31.firebaseio.com/ingredients.json')
        //     .then(res=>{
        //         this.setState({ingredients:res.data});
        //     })
        //     .catch(error=>{
        //         console.log(error);
        //         this.setState({error:true})
        //     });
    }
    updatedIngredientHandler = (ingredients) => {
        const sum = Object.keys(ingredients)
                    .map(igKey=>{
                        return ingredients[igKey]
                    })
                    .reduce((sum,el)=>{
                        return sum+el;
                    },0);
        //this.setState({purchasable:sum>0});
        return sum>0;
    }

    purchaseHandler=() => {
        if(this.props.isAuthenticated) this.setState({purchasing:true});
        else{
            this.props.onSetAuthRedirectPath('/checkout');
            this.props.history.push('/auth');
        }
    }

    purchaseCancelHandler =() => {
        this.setState({purchasing:false})
    }

    // purchaseContinue = () => {
    //     alert('you continue!');
    // }

    purchaseContinue = () => {
        // this.setState({loading:true});
        // const queryParams = [];
        // for(let i in this.state.ingredients){
        //     queryParams.push(encodeURIComponent(i)+'='+encodeURIComponent(this.state.ingredients[i]));
        // }
        // queryParams.push('price='+this.state.totalPrice);
        // const queryString = queryParams.join('&');
        // this.props.history.push({
        //     pathname: '/checkout',
        //     search: '?'+queryString
        // });
        this.props.onInitPurchase();
        this.props.history.push('/checkout');
    }

    render () {
        const disabledInfo = {
            ...this.props.ings
        }
        for(let key in disabledInfo){
            disabledInfo[key] = disabledInfo[key]<=0;
        }
        let orderSummary = null;
        let burger = this.props.error?<p>Can't fetch the ingredients</p>:<Spinner/>;
        if(this.props.ings){
            burger = 
            (<Aux>
                <Burger ingredients={this.props.ings} />
                <BuildControls 
                    ingredientsAdded={this.props.onIngredientAdded}
                    ingredientsRemoved={this.props.onIngredientRemoved}
                    disabled={disabledInfo}
                    price = {this.props.price}
                    //purchasable = {!this.state.purchasable}
                    purchasable = {!this.updatedIngredientHandler(this.props.ings)}
                    ordered = {this.purchaseHandler}
                    isAuth = {this.props.isAuthenticated}
                />
            </Aux>);
            orderSummary = <OrderSummary ingredients={this.props.ings} 
                                purchaseCancelled = {this.purchaseCancelHandler}
                                purchaseContinued = {this.purchaseContinue}
                                price = {this.props.price}
                            />;
        }
        // if(this.state.loading){
        //     orderSummary = <Spinner/>;
        // }
        
        return (
            <Aux>
                <Modal show={this.state.purchasing} modalClosed={this.purchaseCancelHandler}>
                    {orderSummary}
                </Modal>
                {burger}
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return{
        ings: state.burgerBuilder.ingredients,
        price: state.burgerBuilder.totalPrice,
        error: state.burgerBuilder.error,
        isAuthenticated: state.auth.token !== null
    }
}

const mapDispatchToProps = dispatch => {
    return{
        // onIngredientAdded: (ingName)=>dispatch({type:actionTypes.ADD_INGREDIENT,ingredientName:ingName}),
        // onIngredientRemoved: (ingName)=>dispatch({type:actionTypes.REMOVE_INGREDIENT,ingredientName:ingName})
        onIngredientAdded: (ingName)=>dispatch(actions.addIngredient(ingName)),
        onIngredientRemoved: (ingName)=>dispatch(actions.removeIngredient(ingName)),
        onInitIngredients: ()=>dispatch(actions.initIngrerdients()),
        onInitPurchase: ()=>dispatch(actions.purchaseInit()),
        onSetAuthRedirectPath: (path)=>dispatch(actions.setAuthRedirectPath(path))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withErrorHandler(BurgerBuilder,axios));